module.exports = __webpack_public_path__ + "images/hunan_banner01.jpg?ea168c530866181041fe3c49a34ab98a";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/hunan_banner01.jpg
// module id = 187
// module chunks = 1